module.exports = __webpack_public_path__ + "static/img/logo@3x.65f7809.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo@3x.png
// module id = mQrn
// module chunks = 1